import React from 'react';
import SaveEditDetailContainer from '../container/SaveEditDetailsContainer';

function SaveEditDetail() {
  return <SaveEditDetailContainer />;
}

export default SaveEditDetail;
